import { API } from '@aws-amplify/api'
import {
  addReadyForPickup,
  addDispatch,
  addInProgressData,
  addCompleteData,
  updateReceiveSlidesData,
  updateSendSlidesData,
  updateCompleteDataFetchInProgress,
  updateDispachDataFetchInProgress,
  updateProgressDataFetchInProgress,
  updateReadyForPickupFetchInProgress,
  updateLogisticsReceiveSlides,
  updateLogisticsSendSlides,
  errorMessageDisplay,
  addFilterPayload,
} from '../actions'
import { WOMA_API_GATEWAY_NAME } from '../../constants/aws'

interface ReadyForPickupRequest {
  id?: string | null | string[]
  pageIndex?: number | 1
  pageSize?: number | 10
  caseView: string
  filterField: string | null
  filterValue: any | Record<string, unknown> | null //chaanged to Record for linting
  startDate: string | null
  endDate: string | null
  sortOrder: string | null
  sortField: string | null
}

interface DataRequest {
  id?: string | null | string[]
  pageIndex?: number | 1
  pageSize?: number | 10
  caseView: string
  filterField: string | null
  filterValue: any | Record<string, unknown> | null //chaanged to Record for linting
  startDate: string | null
  endDate: string | null
  sortOrder: string | null
  sortField: string | null
}

interface ReceivedSlidesRequest {
  id?: string | null | string[]
  payload?: string | null | string[]
}

export const getDispatchData =
  ({
    id,
    pageIndex,
    pageSize,
    filterField,
    filterValue,
    caseView,
    startDate,
    endDate,
    sortOrder,
    sortField,
  }: DataRequest) =>
  async (dispatch) => {
    if (!id || id instanceof Array) return

    const apiName = '/case-management/logistic/all-cases'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
          filterField: filterField,
          filterValue: filterValue,
          caseView: caseView,
          startDate: startDate,
          endDate: endDate,
          sortOrder: sortOrder,
          sortField: sortField,
        },
      }
      const filterParameters = options.queryStringParameters
      filterParameters['id'] = id
      dispatch(addFilterPayload({ payload: filterParameters }))

      dispatch(updateDispachDataFetchInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}`, options)

      if (result?.data) {
        dispatch(addDispatch({ payload: result, userId: id }))
      }
    } catch (err) {
      console.log('getDispatch Error', err)
    } finally {
      dispatch(updateDispachDataFetchInProgress(false))
    }
  }

export const getReadyForPickupData =
  ({
    id,
    pageIndex,
    pageSize,
    filterField,
    filterValue,
    caseView,
    startDate,
    endDate,
    sortOrder,
    sortField,
  }: ReadyForPickupRequest) =>
  async (dispatch) => {
    if (!id || id instanceof Array) return

    const apiName = '/case-management/logistic/all-cases'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
          filterField: filterField,
          filterValue: filterValue,
          caseView: caseView,
          startDate: startDate,
          endDate: endDate,
          sortOrder: sortOrder,
          sortField: sortField,
        },
      }
      const filterParameters = options.queryStringParameters
      filterParameters['id'] = id
      dispatch(addFilterPayload({ payload: filterParameters }))

      dispatch(updateReadyForPickupFetchInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}`, options)

      if (result?.data) {
        dispatch(addReadyForPickup({ payload: result, userId: id }))
      }
    } catch (err) {
      console.log('getReadyForPickup Error', err)
    } finally {
      dispatch(updateReadyForPickupFetchInProgress(false))
    }
  }

export const getInProgressData =
  ({
    id,
    pageIndex,
    pageSize,
    filterField,
    filterValue,
    caseView,
    startDate,
    endDate,
    sortOrder,
    sortField,
  }: DataRequest) =>
  async (dispatch) => {
    if (!id || id instanceof Array) return

    const apiName = '/case-management/logistic/all-cases'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
          filterField: filterField,
          filterValue: filterValue,
          caseView: caseView,
          startDate: startDate,
          endDate: endDate,
          sortOrder: sortOrder,
          sortField: sortField,
        },
      }
      dispatch(updateProgressDataFetchInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}`, options)

      if (result?.data) {
        dispatch(addInProgressData({ payload: result, userId: id }))
      }
    } catch (err) {
      console.log('getInProgressData Error', err)
    } finally {
      dispatch(updateProgressDataFetchInProgress(false))
    }
  }

export const getCompleteData =
  ({
    id,
    pageIndex,
    pageSize,
    filterField,
    filterValue,
    caseView,
    startDate,
    endDate,
    sortOrder,
    sortField,
  }: DataRequest) =>
  async (dispatch) => {
    if (!id || id instanceof Array) return

    const apiName = '/case-management/logistic/all-cases'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
          filterField: filterField,
          filterValue: filterValue,
          caseView: caseView,
          startDate: startDate,
          endDate: endDate,
          sortOrder: sortOrder,
          sortField: sortField,
        },
      }

      dispatch(updateCompleteDataFetchInProgress({ inProgress: true }))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}`, options)
      if (result?.data) {
        result.data = result?.data.map((value, i) => {
          value.rowId = i + 1
          return value
        })
        dispatch(addCompleteData({ payload: result, userId: id }))
      }
    } catch (err) {
      console.log('getCompleteData Error', err)
    } finally {
      dispatch(updateCompleteDataFetchInProgress({ inProgress: false }))
    }
  }

export const receiveSlidesByCaseId =
  ({ payload, id }: ReceivedSlidesRequest) =>
  async (dispatch) => {
    const apiName = '/case-management/logistic/receive-slides'
    let action = ''
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          caseid: payload,
        },
      }

      const result = await API.put(WOMA_API_GATEWAY_NAME, `${apiName}/${id}?`, options)

        .then(() => {
          action = 'UPDATE_LOGISTICS_RECEIVE_SLIDES_SUCCESS'
          dispatch(updateLogisticsReceiveSlides({ action: action }))
          dispatch(updateReceiveSlidesData({ payload: result }))
        })

        .catch((error) => {
          action = 'UPDATE_LOGISTICS_RECEIVE_SLIDES_ERROR'
          dispatch(updateLogisticsReceiveSlides({ action: action }))
          dispatch(errorMessageDisplay({ payload: JSON.parse(error.response.data).message }))
        })
    } catch (err) {
      console.log(err)
      dispatch(updateLogisticsReceiveSlides({ action: action }))
    }
  }

export const receiveSlidesByCaseIdMessage =
  ({ payload = null, id = null }: ReceivedSlidesRequest) =>
  async (dispatch) => {
    dispatch(updateLogisticsReceiveSlides({ action: 'UPDATE_LOGISTICS_RECEIVE_SLIDES_CLOSE' }))
  }

export const sendSlidesByCaseId =
  ({ payload, id }: ReceivedSlidesRequest) =>
  async (dispatch) => {
    const apiName = '/case-management/logistic/send-slides'
    let action = ''

    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          caseid: payload,
        },
      }
      const result = await API.put(WOMA_API_GATEWAY_NAME, `${apiName}/${id}?`, options)
        .then(() => {
          action = 'UPDATE_LOGISTICS_SEND_SLIDES_SUCCESS'
          dispatch(updateLogisticsReceiveSlides({ action: action }))
          dispatch(updateReceiveSlidesData({ payload: result }))
        })

        .catch((error) => {
          action = 'UPDATE_LOGISTICS_SEND_SLIDES_ERROR'
          dispatch(updateLogisticsReceiveSlides({ action: action }))
          dispatch(errorMessageDisplay({ payload: JSON.parse(error.response.data).message }))
        })
    } catch (err) {
      console.log(err)
      dispatch(updateLogisticsSendSlides({ action: action }))
    }
  }
